// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "แจ้งเตือนลูกค้าให้เปลี่ยนเส้นทาง",
  "1d484fee4a": "ฝ่ายการเงิน, ฝ่ายขาย, การจัดการโครงการ, ข้อมูลธุรกิจ, ฝ่ายผลิตภัณฑ์, ฝ่ายปฏิบัติการ, การจัดการวิจัยและพัฒนา, แผนเวอร์ชัน, ฝ่ายบริการลูกค้า, ฝ่ายบริหาร, ฝ่ายจัดซื้อ, การจัดการหลังการขาย",
  "a2c88dfb79": "สร้างทีมแรกของคุณ",
  "3cfdcc6086": "ฝ่ายการเงิน, ฝ่ายขาย, การจัดการโครงการ/305, การบริหารทรัพยากรบุคคล/306, ฝ่ายปฏิบัติการ, การจัดการวิจัยและพัฒนา, แผนเวอร์ชัน, การจัดการบริการลูกค้า/403, ฝ่ายจัดซื้อ, การจัดการหลังการขาย",
  "ac45ec2c05": "การตรวจสอบการเข้าสู่ระบบบัญชีล้มเหลว",
  "9aef9b8ccd": "บัญชีที่เข้าสู่ระบบในขณะนี้ผิดปกติ กรุณาเข้าสู่ระบบอีกครั้งแล้วลองใหม่",
  "728dd00f22": "หมายเลขโทรศัพท์นี้ตรวจสอบผิดปกติ กรุณาลองใช้การเข้าสู่ระบบด้วยรหัสยืนยันทาง SMS",
  "30dbecd916": "ข้อมูลที่คุณกรอกมีคำที่อ่อนไหว โปรดแก้ไขแล้วลองใหม่",
  "12ed508d8a": "การดำเนินการของคุณถี่เกินไป กรุณาลองใหม่ในภายหลัง",
  "952d4a7595": "สถานะการเข้าสู่ระบบบัญชีนี้ผิดปกติ กรุณาเข้าสู่ระบบอีกครั้งแล้วลองใหม่",
  "e64bfdeaa4": "การตรวจสอบการเข้าสู่ระบบล้มเหลว กรุณาได้รับรหัสยืนยันทาง SMS อีกครั้ง",
  "79008a65f1": "หมายเลขโทรศัพท์นี้ได้เข้าร่วมหลายองค์กรแล้ว กรุณาเข้าสู่ระบบองค์กรหรือเปลี่ยนหมายเลขโทรศัพท์",
  "bf242eff42": "ชื่อองค์กรซ้ำกันอยู่แล้ว",
  "4f0cdb8374": "กรุณากรอกหมายเลขโทรศัพท์ที่สมบูรณ์ หากคุณใช้หมายเลขโทรศัพท์ในต่างประเทศ กรุณาเปลี่ยนเป็นหมายเลขภายในประเทศ (86+)",
  "46e79ffeff": "สร้างองค์กรผิดปกติ กรุณาติดต่อฝ่ายบริการลูกค้าอย่างเป็นทางการเพื่อแก้ไขปัญหา",
  "f3e18f0341": "การตรวจสอบพารามิเตอร์ล้มเหลว",
  "503fd1718d": "การส่งรหัสยืนยันทาง SMS ล้มเหลว",
  "24b3129f19": "การส่งข้อความถี่เกินไป กรุณาลองใหม่ในภายหลัง",
  "1cde3e8245": "รหัสยืนยันไม่ถูกต้อง กรุณากรอกใหม่",
  "4212ecc031": "ตรวจสอบผิดพลาดหลายครั้ง จำกัดการตรวจสอบชั่วคราว กรุณาลองใหม่ในภายหลัง",
  "735da9c347": "การตรวจสอบชื่อองค์กรซ้ำกันมีผิดปกติ กรุณาติดต่อฝ่ายบริการลูกค้าอย่างเป็นทางการเพื่อแก้ไขปัญหา",
  "8731da9615": "การตรวจสอบการรับรองชื่อองค์กรผิดปกติ กรุณาติดต่อฝ่ายบริการลูกค้าอย่างเป็นทางการเพื่อแก้ไขปัญหา",
  "62e89b3f16": "ยอมรับข้อตกลงการให้บริการ",
  "c9b79027e5": "ส่งรหัสยืนยัน",
  "84c1447b9d": "คัดลอกเรียบร้อยแล้ว",
  "fba4b0abd0": "บันทึกโฮสต์",
  "37f5a7cd41": "ค่าของ TXT",
  "78b12427c9": "กำลังรับรอง...",
  "59d089837c": "เรายังไม่สามารถรับรองโดเมนของคุณได้ในขณะนี้ คุณอาจต้องรออีกสักระยะเพื่อให้บริการโฮสต์โดเมนของคุณอัปเดตข้อมูลของคุณ หากยังไม่มีผลตอบสนองในระยะเวลาหนึ่ง โปรดลองยืนยันอีกครั้ง หรือเปลี่ยนโดเมน",
  "4a5b7383d1": "กำลังตรวจสอบบันทึกการยืนยันโดเมน",
  "f24a492e40": "คุณสามารถปิดหน้านี้ได้ แล้วกลับมาดูภายหลัง",
  "c697ca5f1a": "ยินดีต้อนรับสู่เวอร์ชันสำหรับองค์กร",
  "ebb01b1740": "ถัดไป",
  "30109bf753": "องค์กรของคุณมีโดเมนหรือไม่?",
  "2b3e485b47": "ฉันมีโดเมนองค์กร",
  "1a7f5eae44": "ฉันไม่มีโดเมนองค์กร",
  "bde15d6d84": "คุณจำเป็นต้องมีโดเมน (ตัวอย่างเช่น example.com) เพื่อลงทะเบียนบัญชีองค์กร",
  "07ffb22c90": "ขออภัย คุณจำเป็นต้องมีโดเมนเพื่อสร้างบัญชีองค์กรสำหรับองค์กรของคุณ",
  "de23836563": "กรุณาใส่โดเมนสำหรับการสร้างบัญชีองค์กร",
  "287c07944a": "ยืนยันโดเมนของคุณ",
  "3ea2d528d5": "ทำตามขั้นตอนด้านล่างเพื่อพิสูจน์ว่าคุณเป็นเจ้าของ <b>{domain}</b> และป้องกันไม่ให้ผู้อื่นใช้โดเมนนี้ในการลงทะเบียนบัญชีองค์กร",
  "082b18ce56": "เปิดเว็บไซต์ของผู้ให้บริการโดเมนโฮสติ้งใน<a>แท็บใหม่</a> แล้ว<i>เข้าสู่ระบบ</i>บัญชีของคุณ;",
  "4f7e0841a9": "ข. ในเว็บไซต์ผู้ให้บริการโดเมนโฮสติ้ง ไปที่ส่วนของ<b>บันทึก DNS</b> ชื่อของส่วนบันทึก DNS ในหน้าเว็บของผู้ให้บริการโดเมนอาจจะแตกต่างกัน เช่น แสดงเป็น<b>การจัดการ DNS (DNS Management) การจัดการเซิร์ฟเวอร์ชื่อ (Name Server Management) แผงควบคุม (Control Panel) หรือการตั้งค่าขั้นสูง (Advanced Setting)</b>",
  "6365ad6e3a": "จากนั้น <b>กลับมาที่นี่</b> แล้วคลิกที่ \"ถัดไป\" เพื่อเพิ่มบันทึกการยืนยัน",
  "8528892080": "เพิ่มบันทึกการยืนยัน",
  "7a225304f8": "ก. ในหน้า DNS เลื่อนลงไปที่ส่วนของ<b>TXT</b> จากนั้นคลิกปุ่มที่เกี่ยวข้องเพื่อเพิ่มบันทึก",
  "b3cb7d947c": "ข. <b>คัดลอกและวาง</b>ค่าทั้งหมดด้านล่างไปยัง<b>ฟอร์ม TXT</b>ในเว็บไซต์ของผู้ให้บริการโดเมนโฮสติ้ง",
  "47213583bf": "ค. <b>บันทึก</b>บันทึกบนเว็บไซต์ผู้ให้บริการโดเมนของคุณ <br>แล้ว<b>กลับมาที่นี่</b>และคลิกที่ปุ่ม 'ยืนยันโดเมน'",
  "21486a57cf": "หมายเหตุ: ในช่องชื่อ/โฮสต์/ชื่อเล่น คุณสามารถใส่ '@' หรือเว้นว่างไว้ และผู้ให้บริการโดเมนอาจกำหนดให้คุณป้อนชื่อโดเมน (<ชื่อโดเมน>.com) คุณสามารถตัดสินใจโดยดูจากบันทึก DNS อื่น ๆ ว่าควรกรอกข้อมูลในช่องนี้อย่างไร ในช่องเวลาที่จัดเก็บ (TTL) ระบุว่า '86400' หรือเก็บค่าเริ่มต้น",
  "f1b8edab9c": "เปลี่ยนโดเมน",
  "7c6fc663a8": "ยืนยันโดเมน",
  "b6aee9dc0d": "ยืนยันโดเมนสำเร็จ",
  "dd4cc429ea": "ได้รับการพิสูจน์ว่าคุณเป็นเจ้าของ",
  "450f5c9230": "และป้องกันไม่ให้บุคคลอื่นใช้โดเมนนี้ลงทะเบียนบัญชีองค์กร",
  "71cbcba755": "คลิก 'ถัดไป' เพื่อสร้างบัญชีองค์กร",
  "f4084f4870": "กรุณาตั้งค่าบัญชีเข้าสู่ระบบของคุณ",
  "fe3138baec": "เสร็จสิ้นการสร้าง",
  "0315cddedb": "สร้างองค์กรเสร็จสมบูรณ์",
  "91454a7f34": "เข้าสู่ระบบเมนูการจัดการเพื่อสร้างบัญชีองค์กรสำหรับสมาชิกของคุณ",
  "366304cde7": "1. จะถูกล็อกเอาต์จากบัญชี WPS ปัจจุบันอัตโนมัติ",
  "8a9f2a8422": "2. คุณต้องใช้บัญชีองค์กร {account}@{domain} เพื่อเข้าสู่ระบบเมนูการจัดการ",
  "43e265e998": "เข้าสู่ระบบเมนูการจัดการ",
  "9240efaaf0": "ข้อความถูกส่ง",
  "e424bb9a6d": "กรุณาป้อน",
  "d44d581706": "ชื่อองค์กร",
  "aa8679f406": "ความยาว 4-30 อักขระ",
  "581bdb1f98": "ไม่สามารถมีสัญลักษณ์พิเศษ\\/:*?\"<>|{}",
  "c13cabb67a": "อีเมล:",
  "2b9b429e46": "อีเมลของคุณ",
  "5ed834a7df": "กรุณาป้อนอีเมลของคุณ",
  "acfd1f02ed": "กรุณาป้อนอีเมลที่ถูกต้อง",
  "31c7c92cca": ", ยาวสุด 80 ตัว",
  "3f27cf84b3": "กรุณาใส่รหัสยืนยัน",
  "a0ae1f3ec4": "รหัสยืนยันไม่ถูกต้อง",
  "e5589c5e74": "ชื่อของคุณ",
  "69d7bd63f6": ", ใส่ได้เฉพาะตัวอักษรจีน, หรือตัวอักษรหรือตัวเลข",
  "91f008d258": ", ยาวสุด 8 ตัว",
  "6ea6c9b39b": "Phone",
  "161042c5b7": "กรุณาใส่หมายเลขโทรศัพท์ติดต่อ",
  "e6b8eab1cd": "กรุณาใส่หมายเลขโทรศัพท์ติดต่อ, 11 หลัก",
  "3fd5fbb3cc": "กรุณาใส่โดเมนของคุณ",
  "cb5346ba8e": "กรุณาใส่โดเมนองค์กรที่ถูกต้อง, 4~30 ตัว",
  "27928eb7a4": "บัญชี",
  "8e19bd444d": "กรุณาใส่ชื่อบัญชีที่ใช้เข้าสู่ระบบ",
  "7bbbf479dc": "4-20 ตัว, ได้เฉพาะตัวเลข, ตัวอักษรหรือตัวขีดล่าง",
  "3d84cae479": "กรุณากรอกบัญชีที่ตรงตามข้อกำหนด/ตัวอักษรแรกต้องเป็นตัวอักษรหรือตัวเลข",
  "c0d5ece1a7": "รหัสผ่าน",
  "f444036fa8": "ป้อนรหัสผ่าน",
  "b03218d72b": "รหัสผ่านต้องมี 12-16 ตัวอักษรใหญ่และเล็ก, ตัวเลขหรือการรวมกัน 3 แบบ",
  "b4ab05df50": "*องค์กรของคุณได้มีคนใช้งานโดเมนของคุณสำหรับบัญชีองค์กรแล้ว กรุณาติดต่อฝ่ายบริการลูกค้า (400-677-5005) เพื่อยืนยันว่าคุณมีสิทธิ์ในการครอบครองโดเมนนี้",
  "c58876008f": "คัดลอกไม่สำเร็จ กรุณาลองอีกครั้ง",
  "86f73420de": "ลิงก์เชิญ",
  "a58861962c": "ขออภัย เบราว์เซอร์ของคุณไม่รองรับการดาวน์โหลด QR Code นี้",
  "228db07f78": "ฝ่ายการเงิน, ฝ่ายการขาย, การจัดการโครงการ, ข้อมูลธุรกิจ, ฝ่ายผลิตภัณฑ์, ฝ่ายปฏิบัติงาน, การจัดการวิจัยและพัฒนา, แผนการเวอร์ชัน, ฝ่ายบริการลูกค้า, ฝ่ายบริหาร, ฝ่ายจัดซื้อ, การจัดการบริการหลังการขาย",
  "93896d7e98": "หลังจากสร้างทีม เริ่มต้นการทำงานร่วมกันกับเพื่อนร่วมงาน",
  "e8f66fb75c": "ฝ่ายการเงิน, ฝ่ายการขาย, การจัดการโครงการ/305, ทรัพยากรบุคคลและการบริหารงาน/306, ฝ่ายปฏิบัติงาน, การจัดการวิจัยและพัฒนา, แผนการเวอร์ชัน, การจัดการฝ่ายบริการลูกค้า/403, ฝ่ายจัดซื้อ, การจัดการบริการหลังการขาย",
  "831b73da9b": "ชื่อไม่สามารถมีอักขระที่ไม่ถูกต้องและสัญลักษณ์พิเศษ/\\;:*?\"<>|%&",
  "51ab33b3ee": "พารามิเตอร์ไม่ถูกต้อง",
  "a297f9e951": "ชื่อองค์กรซ้ำ",
  "04d60ed5f5": "ไม่สามารถใช้คำต้องห้ามได้",
  "2ff7bef083": "รูปแบบโดเมนผิด",
  "41e1ba2165": "ไม่สามารถตรวจสอบข้อมูล TXT ของโดเมนได้",
  "50f348caa9": "บัญชีซ้ำ",
  "9d4c950d65": "ชื่อถูกลงทะเบียนแล้ว",
  "38cf19ed95": "ชื่อนี้มีอยู่แล้ว",
  "4b426e7c9c": "ชื่อองค์กร",
  "298f880e18": "มีอยู่แล้ว แนะนำให้คุณเพิ่มเติมข้อมูลเพิ่มเติม:",
  "1e67dd20b3": "ค้นหาชื่อองค์กร",
  "517107cb04": "ใช้ชื่ออื่น",
  "5667081882": "ใช้ชื่อนี้สร้าง",
  "e306a979a6": "กรอกเร็ว:",
  "f583db96e0": "*หากชื่อองค์กรถูกใช้แล้ว, คุณสามารถ",
  "9767148e34": "กรุณากรอกชื่อองค์กรหรือองค์กร, 4~100 ตัวอักษร",
  "e0e0ec159f": "ชื่อองค์กร",
  "5b13d254c0": "ชื่อบริษัทนี้มีอยู่แล้ว",
  "92027671ec": "ชื่อบริษัท",
  "36d482a7fb": "ค้นหาชื่อบริษัท",
  "79058a7577": "*หากชื่อบริษัทถูกใช้แล้ว, คุณสามารถ",
  "c96dd48dba": "ชื่อบริษัท",
  "842efad336": "*หากคุณเป็นพนักงานของบริษัท, กรุณา",
  "860f9bd77b": "บริการลูกค้า",
  "5a7ed18daf": "เข้าร่วมองค์กร",
  "ab470e9ace": "ข้อมูลการติดต่อสำรอง",
  "0a7e0e48a7": "ชื่อองค์กรที่เขาขอเข้าร่วม:",
  "a8dc318dcc": "กรุณาตรวจสอบข้อมูลการติดต่อที่คุณกรอก ฝ่ายบริการลูกค้าจะโทรหาคุณในไม่ช้า",
  "6ea1f4d7f5": "ส่งข้อมูล",
  "d439e39f43": "ข้อมูลของคุณได้รับเป็นที่เรียบร้อย",
  "884653426b": "ฝ่ายบริการลูกค้าจะโทรหาคุณภายใน 24 ชั่วโมง โปรดอย่าลืมรับสาย!",
  "2361cb14bf": "สแกน WeChat เพื่อเพิ่มฝ่ายบริการลูกค้าออนไลน์ ตรวจสอบความคืบหน้า",
  "50f45d0031": "การบันทึกล้มเหลว",
  "fc856d0fd2": "ผู้ดูแลระบบระดับสูงสุด",
  "e16c0676d2": "ผู้ดูแลระบบ",
  "b1d2ddd126": "สมาชิกทั่วไป",
  "9d322cc08d": "ชื่อองค์กรไม่สามารถมีสัญลักษณ์พิเศษ \\/:*?\"<>|{}",
  "b583ba7363": "ชื่อบริษัทไม่สามารถมีสัญลักษณ์พิเศษ \\/:*?\"<>|{}",
  "1d118a9bad": "ชื่อองค์กรต้องมีอย่างน้อย 4 ตัวอักษร โปรดป้อนชื่อองค์กรที่มีความยาว 4~100 ตัวอักษร",
  "441b45b1f5": "ชื่อบริษัทต้องมีอย่างน้อย 4 ตัวอักษร โปรดป้อนชื่อบริษัทที่มีความยาว 4~100 ตัวอักษร",
  "97457cb1f0": "ชื่อองค์กรเกิน 100 ตัวอักษร โปรดป้อนชื่อองค์กรที่มีความยาว 4~100 ตัวอักษร",
  "8ce00d3b92": "ชื่อบริษัทเกิน 100 ตัวอักษร โปรดป้อนชื่อบริษัทที่มีความยาว 4~100 ตัวอักษร",
  "a72778d3de": "ชื่อต้องมีอย่างน้อย 2 ตัวอักษร โปรดป้อนชื่อที่มีความยาว 2~10 ตัวอักษร",
  "79c17db5de": "ชื่อเกิน 10 ตัวอักษร โปรดป้อนชื่อที่มีความยาว 2~10 ตัวอักษร",
  "482a118202": "ชื่อรองรับเฉพาะอักษรไทย, ตัวเลข, ภาษาอังกฤษ, ·",
  "9a9be18941": "โปรดทำเครื่องหมายถูก",
  "e6b7c4aa66": "ข้อตกลงการให้บริการออนไลน์",
  "595023d905": "สร้างองค์กร",
  "ba8c2df551": "ซ่อนสถานที่ทั่วไป",
  "d284384975": "ข้อตกลงการให้บริการออนไลน์",
  "5c266d5a84": "นโยบายความเป็นส่วนตัว",
  "fcb92dbcf6": "ข้อตกลงการให้บริการสำนักงานบนคลาวด์",
  "2ae7a8a3f7": "ขอขอบคุณที่เลือกบริการสำนักงานคลาวด์ WPS 365 ต่อไปนี้เป็นคำแนะนำเกี่ยวกับข้อตกลงทางกฎหมายที่คุณและ/หรือองค์กรที่คุณแทนที่ได้รับการบันทึก สมัครสมาชิก และใช้บริการนี้กับ Kingsoft Office",
  "d30a6983bd": "กรุณาอ่าน {0} | {1} | {2} และคลิก \"ตกลง\" ถือว่าท่านยอมรับในเงื่อนไขของข้อตกลงและยอมรับการบริการของเรา",
  "263e306ede": "ฉันได้อ่านและยอมรับ {0} | {1} | {2} แล้ว",
  "440129c0f1": "กรุณาใส่{0}",
  "8ab916983d": "ชื่อบริษัท",
  "b01d68543b": "ชื่อของคุณ",
  "684b30d4e9": "หมายเลขโทรศัพท์ของคุณ",
  "a48427e8e2": "ใช้เพื่อสร้างแพลตฟอร์มการทำงานสำหรับองค์กรของคุณ",
  "3a81b0f1fc": "เพื่อให้เพื่อนร่วมงานพบคุณในระบบและทำงานร่วมกัน",
  "52bc539b6e": "ยืนยันการสร้าง",
  "b2fe245e19": "สร้างองค์กร/ทีม: การแชร์ไฟล์และการทำงานร่วมกัน",
  "893282d3f7": "กรุณาเติมข้อมูลบริษัท:",
  "cc997bf6aa": "ยืนยัน",
  "50fdde51ac": "{0}, {1}~{2} ตัวอักษร",
  "a19cc5ec18": "{0}, ไม่สามารถมีสัญลักษณ์พิเศษ \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0} สามารถป้อนเฉพาะอักษรจีน ตัวอักษร หรือ ตัวเลขเท่านั้น",
  "f4080b1431": "{0} สูงสุด {1} หลัก",
  "88e59b2d58": "{0} ต้องมี 11 หลัก",
  "91d6d4e105": "กรุณาใส่รหัสยืนยัน",
  "bec71bde96": "รหัสยืนยันไม่ถูกต้อง",
  "e20ff8ee19": "{0} ต้องระบุ",
  "8dc09d10d7": "ไม่พบ dwId",
  "a03766ce6c": "โรงเรียน",
  "03542addfe": "องค์กร",
  "adb8a815d1": "หมายเลขโทรศัพท์ที่ผูกกับ {0} ถึงขีดจำกัดแล้ว",
  "97a6b66f1d": "หมายเลขโทรศัพท์ปัจจุบันผูกกับ {0} แล้ว",
  "665e465487": "ไม่สามารถสร้าง{0}ได้ หมายเลขโทรศัพท์มือถือปัจจุบัน “<strong>{1}</strong>” ผูกไว้กับจำนวน{0}สูงสุดแล้ว (สามารถผูกได้สูงสุด 5 {2}) คุณสามารถเข้าสู่{3}ที่ผูกไว้ข้างล่างนี้:",
  "a85b1367ca": "หมายเลขโทรศัพท์ \"{0}\" ได้ผูกกับ {1} แล้ว คุณสามารถเลือก {2} ที่มีอยู่เพื่อเข้าสู่ระบบหรือสร้าง {3} ใหม่:",
  "bf992ce17b": "ใช้หมายเลขโทรศัพท์อื่นสร้าง {0}",
  "395ea04444": "สร้าง {0} ใหม่",
  "4ce3bb86b3": "เข้าร่วม {0} เกินจำนวน",
  "df88c4b7a5": "หมายเลขโทรศัพท์มือถือปัจจุบัน \"{0}\" ผูกจำนวน{1}ถึงขีดจำกัดแล้ว",
  "78f7dd59ca": "หมายเลขโทรศัพท์มือถือปัจจุบัน \"{0}\" ผูก{1}ดังต่อไปนี้ สามารถเปลี่ยนใช้ได้ทันที",
  "8db491a3f8": "สร้าง {0} ใหม่ต่อไป",
  "83f6d9e1e4": "ลองอีกครั้ง",
  "1dc5f11612": "หรือ",
  "217d76f53e": "คำติชม",
  "b69a6ea62a": "กดเมาส์ค้างไว้และขูดเพื่อเปิดเผยโล่สองฝั่ง",
  "3a31f64800": "ยินดีด้วย คุณได้ขูดโล่สำเร็จ<br/>ดำเนินการต่อไปในขั้นตอนถัดไป",
  "6a81fcee96": "กำลังโหลด",
  "e97877a65d": "โอ๊ะ โล่หายไป <br/>กรุณา",
  "8d85456145": "ฉันรอนานเกินไปแล้ว <br/>กรุณา",
  "77ad847b95": "เครือข่ายไม่ค่อยดี <br/>กรุณา",
  "dbd1ae3a34": "คุณขูดเร็วเกินไป <br/>กรุณา",
  "bd8e05cd53": "คลิกปุ่มเพื่อเริ่มการยืนยันอัจฉริยะ",
  "63d2a8a722": "ยืนยันสำเร็จ",
  "73141928ad": "การยืนยันล้มเหลว กรุณาคลิกปุ่มเพื่อรีเฟรช",
  "04856c5c8a": "กำลังตรวจสอบอย่างชาญฉลาด",
  "52cd9bd26d": "การดำเนินการของคุณไม่ได้รับอนุญาต",
  "fd157e8ea8": "สร้างการแนะนำ",
  "c6225c5b2b": "ยินดีต้อนรับเข้าสู่เวอร์ชันบริษัท",
  "e33423fb1e": "สร้างสำเร็จ",
  "7b0c035999": "สร้างหน้าสำเร็จสำหรับ Gold Document Enterprise",
  "85db8faae0": "คำแนะนำสำหรับการใช้เวอร์ชันบริษัท",
  "20591b9b44": "กู้คืนชื่อบริษัท",
  "b023d76dc2": "แนวทางการอัปโหลดสมาชิก",
  "e2f454e095": "บริษัทของ {0}",
  "df466f942b": "สาขา",
  "26a7b797c4": "ศูนย์ย่อย",
  "5fc82b360b": "แพลตฟอร์มบริการสำนักงานครบวงจรช่วยให้คุณทำงานได้อย่างมีประสิทธิภาพมากขึ้น",
  "f2e736d52e": "ยินดีต้อนรับเข้าสู่เวอร์ชันบริษัท",
  "becc41a35b": "ชื่อบริษัท",
  "74685cdc58": "กรุณาใส่ชื่อบริษัทหรือองค์กร 4~100 ตัวอักษร",
  "07b55b1907": "ขนาดธุรกิจ",
  "77b2f763ad": "โปรดเลือกขนาดธุรกิจของคุณ",
  "49d2509109": "น้อยกว่า 5 คน",
  "8db2c9b74a": "6-20 คน",
  "a9fb0cf14a": "21-50 คน",
  "0fed41f8d3": "51-100 คน",
  "fb33f25a04": "101-200 คน",
  "3e3ff0f52e": "201-500 คน",
  "cd8b51f634": "501-2000 คน",
  "0662fa6eec": "มากกว่า 2000 คน",
  "69334dba1a": "ความต้องการของธุรกิจ",
  "79994e749c": "(เราจะเสนอแนวทางปฏิบัติที่ดีที่สุดในอุตสาหกรรมสำหรับธุรกิจของคุณ)",
  "840a017f38": "โปรดเลือกปัญหาที่คุณต้องการแก้ไขมากที่สุด",
  "f045b05c73": "โปรดป้อนความต้องการในการสร้างธุรกิจของคุณ",
  "d8efb0b36d": "เพิ่มเติม",
  "adcb8fbb0c": "หมายเลขโทรศัพท์ที่ใช้บ่อย",
  "eb1c73e2ca": "โปรดป้อนหมายเลขโทรศัพท์ 11 หลักที่คุณใช้บ่อย",
  "7f276e7dfa": "สร้างฟรี",
  "c391b3eec1": "การส่งข้อความล้มเหลว",
  "54f4cb8fa7": "ส่งข้อความแล้ว",
  "231eb1fa1e": "ผู้ใช้ระดับองค์กร_{0}",
  "272b0f9d32": "ผู้ใช้ระดับองค์กร",
  "b209a67331": "การสร้างธุรกิจล้มเหลว โปรดรีเฟรชหน้าเว็บ",
  "acb08d0cc9": "ขั้นตอนที่ 3 ของการสร้างธุรกิจ",
  "83db361f51": "หลังจากสร้างเสร็จสิ้น ให้เรียกใช้ลอจิกการเปลี่ยนแปลง",
  "1e930326e3": "handleStep เข้าสู่ขั้นตอนต่อไป",
  "184df5c725": "saveForm ล้มเหลว",
  "736eab3023": "ตรวจสอบการส่ง",
  "2db62dc13c": "การตรวจสอบล้มเหลว",
  "54fb0afaea": "ตรวจสอบสำเร็จ",
  "d39cff3fcf": "ข้ามการบันทึกแบบลึกสุด แล้วพบว่าต้องการรหัสยืนยัน",
  "305b777ae5": "การตรวจสอบชื่อไม่สำเร็จ เปิดป๊อปอัป \"ชื่อธุรกิจที่ถูกใช้งาน\" และจัดเก็บชื่อ",
  "e57b6686b2": "ตรวจสอบว่าสถานะการรับรองได้รับการยืนยันแล้วหรือยัง เปิดป๊อปอัปคำแนะนำคุ้มครองการรับรอง และจัดเก็บข้อมูลหัวข้อการรับรองที่เกี่ยวข้อง",
  "f7c86f496d": "การสร้างชื่อซ้ำ || รหัสผ่านหมดอายุ หากมีข้อผิดพลาด ให้ปิดกั้นการดำเนินการ",
  "cb37db4fd4": "การส่งล้มเหลว",
  "243a569fc4": "ชื่อนี้ได้รับการลงทะเบียนแล้ว โปรดใช้ชื่ออื่น",
  "196851a3d9": "ผู้ใช้ระดับองค์กร_{0}",
  "0c3a3595ff": "ผู้ใช้ระดับองค์กร",
  "a33b41e0f2": "การสร้างธุรกิจล้มเหลว โปรดรีเฟรชหน้าเว็บ",
  "fcce6a7156": "สร้างสำเร็จ",
  "5ec6da58a6": "แจ้งเตือนลูกค้า",
  "259c9dfa4e": "ลอจิกเวอร์ชันมืออาชีพ",
  "864156930f": "ลอจิก vba",
  "7824efd172": "เอกสาร WPS เวอร์ชันมือถือ",
  "52b6cfaaaf": "ไคลเอนต์ WPS",
  "c7c51beea9": "เวอร์ชันการศึกษา",
  "8d054d4986": "ไคลเอนต์ค่าเริ่มต้น",
  "b597e18fb1": "isWps365PcClient และมี openurl",
  "b0c13de2a0": "isWps365PcClient หรือไม่ใช่ client, มี openurl",
  "7d0f2ce18c": "isWps365PcClientหรือไม่ได้เป็นclient, มีเรียกกลับopenurlสำเร็จ",
  "e2c5a07df6": "ไม่ใช่ client ไม่ใช่ openurl",
  "29e0414d1f": "ไม่ใช่ client ไม่ใช่ openurl callback",
  "60861f7d2a": "autoChange ให้ฝ่ายธุรกิจสลับใช้งานเอง",
  "7c83140d90": "สร้างสถานะผู้เยี่ยมชมไม่ต้องเปลี่ยนผ่าน sdk (sdk ไม่รองรับผู้เยี่ยมชม), code เปลี่ยนผ่านอินเทอร์เฟซสำเร็จแล้ว",
  "3379b09e59": "มี openurl และใช้ href สลับ",
  "586ff04c22": "ไปเดี่ยว",
  "b6c91f218b": "useSuccessSkip ล้มเหลว",
  "47d2f3ba66": "เพิ่มเติม",
  "57551f86ce": "ตามแหล่งที่มาของ utm เพื่อทริกเกอร์วิธีข้ามไปยังต่างกัน",
  "64fe3758e2": "การกระทำของคุณไม่ได้รับอนุญาต",
  "4da3e1262f": "สร้างสำเร็จ เริ่มการทำงานของบริษัท",
  "c38dfb8c6c": "สร้างทีมแรกของคุณ",
  "38dddb483b": "เข้าสู่บริษัท",
  "614d9c91eb": "เชิญสมาชิกเข้าร่วม",
  "97f1eca0aa": "เข้าสู่บริษัท",
  "13a4939e90": "เข้าร่วมคำเชิญของบริษัท",
  "a319e4ae0a": "เชิญเพื่อนร่วมงานเข้าร่วม",
  "12e4da6bba": "เชิญเพื่อนร่วมงานทันที",
  "bd885380f6": "ล้มเหลวในการรับลิงก์คำเชิญ",
  "5e626c4063": "ส่ง SMS แล้ว",
  "3dc09e7cfd": "ขอโทษ, จำนวนชื่อบริษัทที่คุณได้รับการร้องขอคืนค่าถึงขีดจำกัดแล้ว",
  "48318f41f9": "เชิญสมาชิกเข้าร่วม",
  "45441baac4": "เชิญคุณเข้าร่วม {0} สำหรับการทำงานร่วมกัน",
  "e5847fbd67": "คัดลอกลิงก์ เชิญสมาชิก",
  "23101dd40a": "กำลังปรับแต่งโซลูชันสำหรับคุณ",
  "71bb7e54a8": "การจัดการโครงการ",
  "aff37c79cc": "สัมผัสประสบการณ์แผนที่เลือก",
  "a97b174258": "เชิญเพื่อนร่วมงานอีก 2 ท่านเข้าร่วม เพื่อรับสิทธิประโยชน์ทางธุรกิจฟรีดังต่อไปนี้",
  "253855849f": "แชร์ลิงก์คำเชิญไปยังกลุ่มงานเพื่อเชิญเพื่อนร่วมงาน",
  "57b0a2a63f": "คัดลอกลิงก์ เชิญเพื่อนร่วมงาน",
  "71c0a37ee1": "เข้าสู่บริษัท",
  "f848c60e0e": "เชิญ<color:red>2</> เพื่อนร่วมงานเข้าร่วมอีกครั้ง รับสิทธิ์ของบริษัทต่อไปนี้ฟรี",
  "664e32b4fe": "หน้าคำเชิญ เข้าสู่บริษัท",
  "872f14403a": "เชิญเพื่อนร่วมงานเข้าร่วม",
  "1880e7deb9": "เชิญเพื่อนร่วมงานทันที",
  "cc2a9aaf82": "สร้างสำเร็จ",
  "02a13e2583": "เชิญเพื่อนร่วมงานอีก 2 ท่านเข้าร่วม เพื่อรับสิทธิประโยชน์ทางธุรกิจฟรีดังต่อไปนี้",
  "5d3593cdce": "ล้มเหลวในการรับข้อมูลทีม",
  "c025113ea1": "ล้มเหลวในการรับลิงก์คำเชิญ",
  "b83bc1e485": "ลิงก์คำเชิญ",
  "0996ced9f6": "ขอโทษ, เว็บเบราว์เซอร์ของคุณในปัจจุบันไม่สนับสนุนการดาวน์โหลดรหัส QR นี้",
  "1e88451e31": "คัดลอกลิงก์คำเชิญแล้ว",
  "bb969cabcd": "คัดลอกล้มเหลวโปรดลองอีกครั้ง",
  "15e1f79c7a": "สมัครเข้าร่วมบริษัท",
  "59c22b4ef8": "ได้รับลิงก์คำเชิญแล้ว",
  "0f0b392e60": "สร้างทีมแรกของคุณ",
  "0437d07c43": "ชื่อบริษัท",
  "41800c7bf1": "กรุณากรอกชื่อผู้สร้าง",
  "1ec5999511": "ชื่อผู้สร้างยาวสูงสุด 8 ตัวอักษร",
  "02da35b4e4": "ชื่อผู้สร้างสามารถใช้ได้เฉพาะตัวอักษรจีน, ตัวอักษร และตัวเลข",
  "184e9f6616": "กรุณากรอกเบอร์โทรศัพท์ติดต่อ",
  "9b587898ba": "กรุณากรอกเบอร์โทรศัพท์ในรูปแบบที่ถูกต้อง",
  "e68c164a02": "กรุณากรอกอีเมลของคุณ",
  "0b1de22df7": "กรุณากรอกรูปแบบอีเมลที่ถูกต้อง",
  "61026181ab": "จำเป็นต้องมีใบอนุญาตประกอบธุรกิจ",
  "c3847e604e": "ขนาดไฟล์เกิน 10M กรุณาเลือกใหม่",
  "49450f4ec7": "ต้องกรอกแบบฟอร์มอุทธรณ์การใช้ชื่อซ้ำ",
  "39c3b8fa1d": "เกิดข้อผิดพลาดในการส่ง",
  "3ea44d7963": "อัปโหลดสำเร็จ",
  "5b1aa3c2c4": "อัปโหลดไม่สำเร็จ",
  "7e7f81eaa3": "อัปโหลดไม่สำเร็จ ไฟล์ใหญ่เกิน 10M",
  "2ff1913de1": "การอัปโหลดล้มเหลว ไฟล์ต้องเป็น.jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "จำเป็นต้องมีใบอนุญาตประกอบธุรกิจ",
  "66bda65057": "ขนาดไฟล์เกิน 10M กรุณาเลือกใหม่",
  "8f2305a83d": "ต้องกรอกแบบฟอร์มอุทธรณ์การใช้ชื่อซ้ำ",
  "55ff0c8c6e": "เกิดข้อผิดพลาดในการส่ง",
  "8dad6d950d": "เกิดข้อผิดพลาดในการรับข้อมูลเชิญ",
  "a5f0ac3a9a": "สร้างสำเร็จ",
  "4f1d069770": "พารามิเตอร์ utm ของหน้าคำเชิญคือ {0} และชื่อ {1}",
  "f9578cfe6d": "พารามิเตอร์ utm ของการเข้าถึงสองขั้นตอนคือ {0} และชื่อ {1}",
  "e10d028405": "ขั้นตอนที่สองในการชี้นำ pcoffice ที่สร้างขึ้นแล้ว",
  "8e22e4fcc4": "คัดลอกลิงก์คำเชิญแล้ว",
  "3f327f9f37": "ข้อผิดพลาดในการคัดลอก กรุณาลองใหม่",
  "bd1aecb265": "ยกเลิก",
  "b6abf9b19a": "ยอมรับ",
  "e910d9cc0f": "ยกเลิก",
  "37ab25522d": "ยอมรับ",
  "196b3eb9cf": "สแกนคิวอาร์โค้ดเข้าร่วม",
  "2b81c52e20": "ดาวน์โหลดรูปภาพ",
  "62152fd9f3": "คำเชิญลิงก์",
  "e0a3725651": "ขออภัย เบราว์เซอร์ของคุณไม่รองรับการดาวน์โหลดคิวอาร์โค้ดนี้",
  "8b7883b2c7": "สแกนคิวอาร์โค้ดเข้าร่วม",
  "9e9a659ed5": "ดาวน์โหลดรูปภาพ",
  "0d55065a9a": "คำเชิญลิงก์",
  "487cf6a106": "ขออภัย เบราว์เซอร์ของคุณไม่รองรับการดาวน์โหลดคิวอาร์โค้ดนี้",
  "78fd005d1f": "กรุณากรอกหมายเลขโทรศัพท์มือถือ",
  "f909563857": "ใช้หมายเลขนี้สร้าง",
  "a26a19f139": "ยกเลิกการสร้าง",
  "cc004ac9ee": "หมายเลขโทรศัพท์มือถือ",
  "4df8c3c588": "ใช้เบอร์โทรศัพท์มือถืออื่นสร้างโรงเรียน",
  "3151cabb3d": "ใช้เบอร์โทรศัพท์มือถืออื่นสร้างบริษัท",
  "56098a71eb": "คลิกตรวจสอบอัจฉริยะ ส่งรหัสยืนยัน",
  "e96ec218e4": "กรุณากรอกรหัสยืนยันทางข้อความ",
  "ce619a0225": "ส่งรหัสยืนยันทางข้อความไปที่",
  "0e9863aaeb": "รหัสยืนยันไม่ถูกต้อง กรุณากรอกใหม่",
  "32dc8629e1": "ส่งใหม่ในไม่กี่วินาที",
  "e4eda9add5": "ส่งอีกครั้ง",
  "b007977564": "เกิดข้อผิดพลาดในการรับข้อมูลการอนุมัติ",
  "d8852ffc9c": "ไม่ใช่ผู้ดูแลเข้าใช้งาน",
  "8a733a2574": "การเข้าถึงผ่านมือถือ",
  "9e8c152c4f": "เข้าถึง PC",
  "2265a55e93": "ยอมรับข้อตกลงการให้บริการ",
  "80dabe5aa3": "สร้างคำแนะนำ",
  "7deee8bf5a": "ขั้นตอนที่สองในการชี้นำ docsWeb ที่สร้างขึ้นแล้ว",
  "69eb501ecb": "คำอุทธรณ์ของคุณหมดอายุแล้ว ไม่สามารถเข้าถึงได้",
  "aa1d9d98ad": "การอนุญาตไม่เพียงพอ ไม่สามารถเข้าถึงได้",
  "fdf2fe129e": "สร้างองค์กร",
  "7f0ca0df6b": "ซ่อนสถานที่ทั่วไป",
  "cc6ac2a93c": "การแนะนำสองขั้นตอนฐานติดตั้งแล้ว",
  "5d6c570bf0": "การแนะนำสองขั้นตอนก่อนหน้า",
  "a4eb8a192d": "ทีมที่ทุกคนกำลังสร้าง",
  "4912e16a9d": "ชื่อบริษัทถูกกู้คืนแล้ว",
  "41c4e87ef2": "คุณสามารถคลิกที่ลิงก์",
  "5e630930c0": "สร้างบริษัทใหม่",
  "436a563524": "หากคุณสร้างบริษัทแล้ว คุณสามารถอ้างอิง",
  "0b6e7cbe7f": "วิธีการแก้ไขชื่อบริษัท",
  "cb7bce0775": "สอนการเปลี่ยนชื่อบริษัท",
  "3feadd3040": "เวอร์ชันปัจจุบันต่ำเกินไป ไม่สามารถใช้งานบริษัทได้",
  "3cf23de936": "เวอร์ชันซอฟต์แวร์ของคุณต่ำเกินไป ฟังก์ชันบริษัทไม่สามารถใช้งานได้ กรุณาไปที่ตลาดแอปเพื่ออัปเดตซอฟต์แวร์!",
  "a1c5d5d202": "ตกลง",
  "e50183bd00": "WPS คลาวด์",
  "e5031ab679": "ความปลอดภัย การซิงค์ การทำงานร่วมกัน",
  "c870026dfc": "เข้าสู่ระบบด้วย WeChat",
  "e7647cd875": "เข้าสู่ระบบด้วยบัญชี WPS",
  "07b380074b": "เข้าสู่ระบบด้วย QQ",
  "67921724dd": "วิธีอื่นๆ",
  "254da8a9f5": "จำนวนการเข้าร่วม/สร้างบริษัทถึงขีดจำกัด",
  "3648e4811b": "เข้าสู่ WPS Docs",
  "dcd102b346": "สร้างทีมที่กำหนดเอง",
  "8b9b258cbf": "ป้อนชื่อทีมที่นี่",
  "19bb6e0ded": "สิทธิพิเศษของสมาชิก WPS",
  "2d9fe8d938": "สิทธิพิเศษในการทำงานแก้ปัญหาของคุณในงานเอกสารประจำวัน มาลองกันเถอะ!",
  "e8c1caa649": "อัปโหลดจากเครื่อง",
  "03641083a3": "ย้ายจาก 'เอกสารส่วนบุคคล'",
  "eecd3ab9b5": "ครั้งถัดไป",
  "13b447b3a8": "แทนที่",
  "3c2fc507fc": "เวอร์ชันปัจจุบันต่ำเกินไป ไม่สามารถใช้งานบริษัทได้",
  "c3615d8134": "เวอร์ชันซอฟต์แวร์ของคุณต่ำเกินไป ฟังก์ชันบริษัทไม่สามารถใช้งานได้ กรุณาไปที่เว็บไซต์หลักเพื่ออัปเดตซอฟต์แวร์!",
  "644a36e05b": "ไปอัปเดต",
  "d435105f21": "จำนวนการเข้าร่วม/สร้างบริษัทถึงขีดจำกัด",
  "73a286ceb0": "เข้าสู่ WPS Docs",
  "c2cec645c0": "ยกเลิก",
  "b5f5b83c0f": "ยอมรับ",
  "76ec352da5": "สแกนโค้ดเชิญพนักงาน",
  "6a509e4487": "ดาวน์โหลดคิวอาร์โค้ด",
  "940cc4a546": "ไม่สามารถสร้างบริษัท",
  "78b2a62ea5": "เข้าสู่บริษัทที่มีอยู่หรือสร้างบริษัทใหม่",
  "3a6da7f6f9": "จำนวนหมายเลขโทรศัพท์มือถือที่ผูกกับบริษัทได้ถึงขีดจำกัด (สามารถผูกได้สูงสุด 5 บริษัท)",
  "93bab52870": "หมายเลขโทรศัพท์ปัจจุบันผูกกับบริษัทแล้ว คุณสามารถเลือกเข้าสู่ระบบบริษัทที่มีอยู่:",
  "ce6e0adaf2": "คุณสามารถเลือกเข้าสู่บริษัทที่ผูกแล้วด้านล่าง:",
  "1ce200a92b": "เลือก",
  "bb91ef2999": "สร้างบริษัทใหม่",
  "024e4a91e5": "ชื่อบริษัทถูกใช้แล้ว",
  "eb089a23a0": "ชื่อบริษัทนั้นถูกใช้แล้ว:",
  "7646558701": "ผู้ดูแลระบบ:",
  "1d9c02bd33": "เวลาลงทะเบียน:",
  "919fc7805f": "เราแนะนำให้คุณพยายามหาหรือพบปะกับเพื่อนร่วมงานของคุณที่ระบุไว้ข้างต้น",
  "0ca71a9344": "คุณยังสามารถใช้ชื่ออื่นสร้างบริษัทชั่วคราว (สามารถเปลี่ยนแปลงได้ในภายหลัง) แล้วส่งคำร้อง",
  "e83a244e90": "คลิกเพื่ออ่านวิธีการอุทธรณ์",
  "d22bedfb21": "ใช่",
  "907b78b6e5": "ป้อนชื่อกลุ่มหรือทีม",
  "7195b0ac1e": "ทีมที่คุณอาจต้องการสร้าง",
  "60ed4f915e": "ถัดไป",
  "f5ba8dfb7b": "ข้ามการแนะนำ",
  "5c44a3ef68": "สูงสุด 100 ตัวอักษร",
  "130c53fb20": "ชื่อไม่สามารถมีอักขระหรือสัญลักษณ์พิเศษเช่น /\\;:*?\"<>|%& ได้",
  "e832d41acc": "แนะนำสองขั้นตอน ข้าม",
  "80d9cf7177": "แนะนำสองขั้นตอน รีเฟรช",
  "0aebf80435": "แนะนำสองขั้นตอน คลิกลิ้งค์",
  "e74f515977": "แนะนำสองขั้นตอน ส่ง",
  "308d2a53c9": "แนะนำสองขั้นตอน สร้างกลุ่ม",
  "dda2ed7e18": "แนะนำสองขั้นตอน สร้างทีมไม่สำเร็จ",
  "ded3c35500": "สร้างทีมไม่สำเร็จ",
  "4f18031bc1": "แนะนำสองขั้นตอน สร้างแม่แบบ",
  "091e5cefcc": "แนะนำสองขั้นตอน ข้อผิดพลาดในการสร้างแม่แบบ",
  "58cf4e00f0": "รหัสยืนยัน",
  "92abbf0385": "ส่งรหัสยืนยัน",
  "f0f9976ef9": "โปรดป้อนหมายเลขโทรศัพท์ของคุณ",
  "a4ce99b1df": "รหัสยืนยัน",
  "39d36e0f9f": "ยืนยัน",
  "0fd8a01938": "ส่ง",
  "9048a4e842": "หมายเลขโทรศัพท์",
  "9afa1091eb": "ส่งอีกครั้ง",
  "58d787001f": "ป้อนหมายเลขโทรศัพท์อื่นเพื่อสร้างโรงเรียน",
  "450905a265": "ป้อนหมายเลขโทรศัพท์อื่นเพื่อสร้างบริษัท",
  "f7386de3c6": "เลือกจากรายการ",
  "27aa05a92c": "ยอมรับข้อตกลงการให้บริการ",
  "80af61cb57": "กลับไปหน้าก่อนหน้า",
  "50149b8d4f": "ชื่อผู้สมัคร",
  "e6756f8749": "กรุณาใส่ชื่อของคุณ",
  "3cbd51a2b1": "ชื่ออย่างน้อย 2 อักษร, กรุณาใส่ชื่อ 2 ถึง 10 อักษร",
  "4f79b4813f": "ชื่อสามารถใช้ได้เฉพาะอักษรจีน ตัวเลข อังกฤษ และ · เท่านั้น",
  "71d3e75983": "หมายเลขโทรศัพท์ที่ใช้บ่อย",
  "afe5149035": "กรุณาใส่หมายเลขโทรศัพท์ที่ใช้บ่อย",
  "1e9270b50f": "กรุณาใส่หมายเลขโทรศัพท์ที่ใช้บ่อย, เป็น 11 ตัวเลข",
  "ff5dc98dfb": "ข้าม",
  "165be2ab43": "กลับไปขั้นตอนก่อนหน้า",
  "231d8a335a": "ยอมรับข้อตกลงการให้บริการ",
  "1cad008ffc": "ชื่อนิติบุคคล {0} ถูกลงทะเบียนแล้ว กรุณาใช้อื่น",
  "c6e274fcab": "ยืนยันข้อตกลง",
  "b9352504bb": "ปิดหน้าต่างข้อตกลง",
  "8409e99ad0": "เปิดหน้าต่างข้อตกลง",
  "1593c6dd95": "ส่ง",
  "4f44a9de22": "เปิดการยืนยัน SMS",
  "26b70c68b8": "ข้ามเข้าสู่บริษัททันที",
  "a8bebcb302": "กลับไปหน้าก่อนหน้า",
  "c800b4fec5": "หน้าถูกติดตั้งฐาน",
  "38b396d5b0": "หน้าการเชิญ DocsWeb ถูกติดตั้ง",
  "2eb7f9a9f1": "การอุทธรณ์ของคุณได้รับการส่งสำเร็จ",
  "2c6f3590fb": "เราคาดว่าจะส่งผลการดำเนินการไปยังอีเมลของคุณภายใน 3 วันทำการ",
  "2ea3eff708": "กรุณาตรวจสอบ",
  "53acfba22c": "เชิญเพื่อนร่วมงานทันที",
  "4e6d282f4f": "เข้าร่วมการเชิญของบริษัท",
  "5f72f4b936": "เชิญเพื่อนร่วมงานทันที",
  "e5383077ba": "กู้คืนชื่อองค์กร",
  "06e3fa2350": "หลังจากการสืบค้น,",
  "653a263b5e": "ผู้สร้างคือ",
  "769f57269f": "หมายเลขโทรศัพท์ของผู้สร้างคือ",
  "09a224695e": "โปรดยืนยันว่าผู้สร้างองค์กรนี้เป็นเพื่อนร่วมงานของคุณหรือไม่",
  "3beda6c149": "หากเป็นเพื่อนร่วมงานของคุณ โปรดติดต่อเขา",
  "5c74dd10d1": "แก้ไขชื่อองค์กรหรือโอนการเป็น super administrator",
  "da504edb0f": "หากไม่ใช่เพื่อนร่วมงานของคุณ โปรดคลิกปุ่มด้านล่างเพื่อดำเนินการต่อในการกู้คืนชื่อบริษัท",
  "39194faaf1": "ดำเนินการค้นหาชื่อองค์กรต่อไป",
  "e22b829e90": "คัดลอกเรียบร้อยแล้ว",
  "6e1b44752a": "ค่า TXT",
  "79881b1d7a": "เชิญเพื่อนร่วมงานทันที",
  "a5344a45f9": "คลิกที่มุมขวาบน เลือก \"ส่งให้เพื่อน\"",
  "a4954a5b08": "เชิญเพื่อนร่วมงานทันที",
  "8e3a1625fb": "ค้นหาชื่อองค์กร",
  "bf8b8c7005": "อัปโหลดใบทะเบียนพาณิชย์ขององค์กร",
  "bfd44a66c9": "คลิกเพื่อเลือก",
  "d503f20925": "โปรดอัปโหลดสแกนหรือภาพใบทะเบียนพาณิชย์ขององค์กร",
  "cbebe043c5": "รองรับรูปแบบ JPG, JPEG, PNG, BMP, PDF ขนาดไม่เกิน 10 MB",
  "9650b96d7d": "อัปโหลดเอกสารการร้องเรียนเรื่องชื่อเดียวกัน",
  "c3b8ae46d3": "โปรดอัปโหลดสแกนหรือภาพเอกสารการร้องเรียนเรื่องชื่อเดียวกัน",
  "9e325a9e09": "ดาวน์โหลดเทมเพลตเอกสารข้อมูล",
  "a4711aae88": "ส่งคำขอ",
  "3a5cc1441e": "การรับรอง...",
  "0bd7bf8511": "เรายังไม่สามารถตรวจสอบโดเมนของคุณได้ คุณอาจต้องรออีกสักระยะเพื่อให้บริการโฮสต์โดเมนปรับปรุงข้อมูลของคุณ หากเวลาผ่านไปแล้วยังไม่มีการตอบสนอง โปรดลองตรวจสอบอีกครั้ง หรือเปลี่ยนโดเมน",
  "fae48d554b": "กำลังตรวจสอบโดเมน",
  "5e1779a0ca": "บันทึกการตรวจสอบ คุณสามารถปิดหน้านี้แล้วกลับมาดูอีกทีหลังได้",
  "ca85f8b836": "ยินดีต้อนรับสู่เวอร์ชันองค์กร",
  "2570e0f00b": "เข้าระบบล้มเหลว",
  "40d16a007e": "ได้เชื่อมต่อบัญชีส่วนตัวของคุณโดยอัตโนมัติแล้ว",
  "81376b92e4": "วิธีการเข้าสู่ระบบของ {0} โปรดเข้าสู่ระบบใหม่เพื่อเปลี่ยนบัญชีองค์กร",
  "ba679ba739": "ทราบแล้ว ไปเข้าสู่ระบบ",
  "c05f64c6c6": "หลังจาก {0} ไปที่เข้าสู่ระบบโดยอัตโนมัติ",
  "c329ccef3a": "เข้าระบบล้มเหลว",
  "e370f9afb1": "ได้เชื่อมต่อบัญชีส่วนตัวของคุณโดยอัตโนมัติแล้ว",
  "410cf42585": "วิธีการเข้าสู่ระบบของ โปรดเข้าสู่ระบบใหม่เพื่อเปลี่ยนบัญชีองค์กร",
  "062d48aece": "ทราบแล้ว ไปเข้าสู่ระบบ",
  "95a105d412": "หลังจากนั้นไปที่เข้าสู่ระบบโดยอัตโนมัติ",
  "2d000d5a6d": "ส่งลิงก์แชร์ให้สมาชิก สมาชิกสามารถสมัครเข้าร่วมได้หลังเปิด",
  "8861b6e90d": "เข้าสู่องค์กร",
  "25b9f72fda": "พารามิเตอร์หน้าผิดพลาด",
  "1c76123efc": "ลิงก์เชิญไม่สามารถดึงข้อมูลได้",
  "6caba48b76": "ข้าม",
  "f66379c650": "พารามิเตอร์หน้าผิดพลาด",
  "c45021de2a": "การสร้างล้มเหลว",
  "011d470126": "แพลตฟอร์มยังคงปกป้องข้อมูลของคุณ",
  "f1a44d9151": "แพลตฟอร์มได้รับใบรับรอง ISO27001, ISO27701 จาก BSI ระหว่างประเทศและผ่านการทดสอบความปลอดภัยระดับสามของประเทศ",
  "255ea5dff7": "สมุดปกขาวเกี่ยวกับความปลอดภัย",
  "bb55b124f2": "สร้างการนำเสนอองค์กร",
  "61e24974a3": "สร้างกลยุทธ์เนื้อหาการรับองค์กร",
  "bfdf78febe": "ขั้นตอนถัดไป การทำข้อมูลให้สมบูรณ์",
  "c4aa2d2d60": "ป้อนชื่อกลุ่มงานหรือโครงการ",
  "b69765ab64": "ทีมที่ทุกคนกำลังสร้าง",
  "9657d9408b": "แทนที่",
  "e21da8c16a": "ถัดไป",
  "224ef5cc9f": "ข้ามการแนะนำ",
  "641f58c8f6": "องค์กรปัจจุบันไม่รองรับการสร้างทีม กรุณาติดต่อผู้ดูแลระบบเพื่อสร้าง",
  "efea622752": "คัดลอกลิงก์ เชิญเพื่อนร่วมงาน",
  "fd5b40a9fd": "เชิญคุณเข้าร่วม \"{0}\" เพื่อร่วมงานกัน",
  "b04dd2f10a": "คัดลอกลิงก์เชิญแล้ว",
  "d1606a1b1a": "คัดลอกล้มเหลว กรุณาลองใหม่",
  "0d59f3db83": "ป้อนแผนกโครงการหรือทีม เช่น \"ฝ่ายขาย\"",
  "9429513d34": "ไม่ต้องการคำแนะนำ",
  "b54a20b1ff": "การสร้างล้มเหลว",
  "093fa0fb74": "กำลังให้สิทธิ์การเข้าสู่ระบบ...",
  "b383b136f4": "สร้างการเริ่มต้นโครงการองค์กร",
  "b6b21b388b": "ชื่อองค์กรนี้ได้ถูกใช้แล้ว",
  "285dc68c10": "ชื่อองค์กรนี้ได้ถูกใช้แล้ว:",
  "1bf685b89d": "ผู้ดูแลระบบ:",
  "7b4297edcc": "เวลาลงทะเบียน:",
  "fa51ea19fc": "เราแนะนำให้คุณลองค้นหาและติดต่อเพื่อนร่วมงานของคุณข้างต้น",
  "e3678a996d": "คุณยังสามารถใช้ชื่ออื่นเพื่อสร้างองค์กรชั่วคราว (และสามารถเปลี่ยนได้ในภายหลัง) และส่งคำร้องได้",
  "5969bc8071": "รับทราบ",
  "ba4cf699df": "กู้คืนชื่อองค์กร",
  "afecee4eb4": "ชื่อของคุณ",
  "a8bdebc614": "กรุณาป้อนชื่อของคุณ",
  "5bbeb38a66": "Phone",
  "b4f7b44b7a": "กรุณาป้อนหมายเลขโทรศัพท์ของคุณ",
  "cac2913686": "อีเมลติดต่อ",
  "23d3bb3a42": "กรุณาป้อนอีเมลติดต่อของคุณ",
  "ea106a393c": "อัปโหลดใบทะเบียนพาณิชย์ขององค์กร",
  "f74131d71e": "คลิกเพื่อเลือก",
  "53749c51c5": "กรุณาอัปโหลดใบทะเบียนพาณิชย์หรือภาพถ่าย",
  "c00f2ea171": "รองรับรูปแบบ JPG, JPEG, PNG, BMP, PDF ขนาดไม่เกิน 10 MB.",
  "57ec07fa97": "อัปโหลดแบบฟอร์มแจ้งความซ้ำชื่อ",
  "8eb0606e94": "กรุณาอัปโหลดแบบฟอร์มแจ้งความซ้ำชื่อหรือภาพถ่าย",
  "f59e76c0b0": "ดาวน์โหลดแม่แบบแบบฟอร์มข้อมูล",
  "030bd26fa4": "ส่งคำขอ",
  "0a602dc727": "จัดเก็บข้อมูลอย่างปลอดภัย",
  "9138f28acf": "แชร์ไฟล์เพื่อความร่วมมือ",
  "b3a306cf90": "การปฏิบัติตามข้อกำหนดอย่างถูกต้อง",
  "973c53f725": "แนะนำให้เปลี่ยนชื่อ หลังจากลงทะเบียนสามารถส่งข้อมูลรับรองและอัปเดตชื่อได้",
  "f886f5e92f": "แนะนำให้เปลี่ยนชื่อ หลังจากลงทะเบียนสามารถส่งการรับรององค์กรและอัปเดตชื่อได้",
  "b8051702a3": "ชื่อมีคำที่มีความอ่อนไหว กรุณาปรับหรือติดต่อฝ่ายบริการลูกค้า",
  "d73881f7d4": "ชื่อองค์กรนี้ได้รับการป้องกัน",
  "dc7e58e320": "ชื่อองค์กรนี้ได้รับการป้องกัน จำเป็นต้องยืนยันข้อมูลตัวตนก่อนใช้ ขอแนะนำให้เปลี่ยนชื่อองค์กรหรือหลังจากลงทะเบียนแล้วทำการรับรององค์กรเพื่อใช้ชื่อดังกล่าว",
  "20c3bc070c": "ยืนยัน",
  "c4278e5f28": "สิทธิ์ไม่เพียงพอ",
  "9217efae21": "บัญชีที่คุณเข้าสู่ระบบยังไม่มีสิทธิ์สร้าง โปรดติดต่อฝ่ายขายเพื่อดำเนินการ",
  "52ff08f2ad": "ชื่อหน่วยงานได้รับการป้องกัน โปรดแก้ไขชื่อองค์กร",
  "79386ae280": "โปรดป้อนรหัสยืนยัน 6 หลัก",
  "d7b2c5a41b": "ส่งรหัสยืนยันไปยังแล้ว",
  "ce2e1c26f7": "(มีผลภายใน 10 นาที)",
  "59d338903f": "สามารถขอรับรหัสยืนยันใหม่ได้ใน {0} วินาที",
  "5aadd14136": "ขอรับรหัสยืนยันใหม่",
  "90f5c93432": "ชื่อนี้ได้ถูกลงทะเบียนแล้ว",
  "1677072f4a": "คุณสามารถกรอกข้อมูลเพิ่มเติม หรือใช้ชื่ออื่นในการลงทะเบียน",
  "3b8459fb1e": "เติมอย่างรวดเร็ว:",
  "6f38edbcb1": "ใช้ชื่อนี้ลงทะเบียน",
  "8406c81e2d": "สาขา",
  "29d323fa85": "ศูนย์ย่อย",
  "4f0e806e02": "ฝ่ายการเงิน",
  "3f935efb6b": "ยอมรับเงื่อนไขการให้บริการ",
  "b42241be05": "ยังไม่",
  "99de4b33b7": "ยอมรับ",
  "7f867e7395": "ใช้หมายเลขโทรศัพท์อื่นเพื่อสร้างธุรกิจ",
  "0d51a8f7a6": "ดำเนินการสร้างต่อ",
  "8bdaecf2e5": "โปรดป้อนหมายเลขโทรศัพท์ของคุณ",
  "565ae60c8a": "โปรดป้อนชื่อของคุณ",
  "f76e06d0e7": "โปรดป้อนหมายเลขโทรศัพท์ของคุณ",
  "7b0fca5255": "โปรดป้อนรหัสยืนยัน",
  "68026d2d25": "ยินดีต้อนรับสู่เวอร์ชันองค์กร",
  "d25b5541be": "สร้างฟรี",
  "32cfd73733": "โปรดป้อนชื่อทีม องค์กร หรือกลุ่ม",
  "4cf83dc4a0": "สร้างอย่างรวดเร็วในหนึ่งนาที เพื่อให้ร่วมมืองานกับเพื่อนร่วมงานได้อย่างมีประสิทธิภาพ",
  "d320d37116": "สร้างทีม/องค์กรฟรี",
  "c54b475dd2": "ข้อตกลงผู้ใช้",
  "190d54e616": "องค์กรของ {0}",
  "8c1b768ac4": "การยืนยันอัจฉริยะล้มเหลว",
  "d74eab0f35": "ชื่อองค์กรของคุณไม่ตรงตามบรรทัดฐานของแพลตฟอร์ม โปรดแก้ไขและลองอีกครั้ง",
  "0f3d62dd4f": "ข้อมูลชื่อของคุณไม่ตรงตามบรรทัดฐานของแพลตฟอร์ม โปรดแก้ไขและลองอีกครั้ง",
  "647cf2211b": "ไม่สนับสนุนการสร้างด้วยหมายเลขโทรศัพท์ปัจจุบัน โปรดเปลี่ยนหมายเลขโทรศัพท์",
  "b63d96cdae": "ข้อมูลที่กรอกไม่ตรงตามบรรทัดฐานของแพลตฟอร์ม โปรดแก้ไขและลองอีกครั้ง",
  "2dbbe8e43f": "ไม่สนับสนุนการสร้างด้วยหมายเลขโทรศัพท์ปัจจุบัน โปรดแก้ไขและลองอีกครั้ง",
  "b18abc5de6": "ไม่มีหมายเลขโทรศัพท์ที่ผูกไว้",
  "f5233dae6f": "โปรดเปลี่ยนหมายเลขโทรศัพท์เพื่อสร้าง",
  "4167c8b88d": "หมายเลขโทรศัพท์ปัจจุบันอาจมีสถานการณ์ต่อไปนี้ โปรดลองเปลี่ยนหมายเลขโทรศัพท์ หากมีข้อสงสัย โปรดติดต่อฝ่ายบริการลูกค้า",
  "a8a2433c4d": "สแกน QR Code โดย WeChat เพื่อเพิ่มและติดต่อฝ่ายบริการลูกค้า",
  "444a639c09": "เข้าใจแล้ว",
  "69a097057f": "หมายเลขโทรศัพท์ปัจจุบันเป็นหมายเลขผู้ให้บริการเสมือน<#BB2726>",
  "4370b06fd0": "หมายเลขโทรศัพท์ปัจจุบันมีพฤติกรรมการใช้งานที่ผิดปกติ<#BB2726>",
  "8c49e1dc4a": "ต้องทำการยืนยันมนุษย์-เครื่องจักร",
  "4b8ba7d8cc": "แพลตฟอร์มประสิทธิภาพใหม่ของการจัดการออฟฟิศ",
  "81be771e17": "🎉สร้างองค์กรสำเร็จ! กรอกข้อมูลเพิ่มเติมเพื่อรับบริการพิเศษ",
  "461125b057": "สามารถจัดการเอกสารและข้อมูลในทีมได้ สมาชิกทีมสามารถดูได้อย่างสะดวก นอกจากนี้ยังสามารถตั้งค่าการแก้ไข/ดาวน์โหลดเพื่อความปลอดภัยของข้อมูล",
  "c3eb25029b": "ขนาดบริษัท/ทีม",
  "049f8401ec": "น้อยกว่า 5 คน",
  "c81896349e": "6-20 คน",
  "7357daac4e": "21-50 คน",
  "f0e65a0a29": "51-100 คน",
  "b9fac8204a": "101-200 คน",
  "62d73dddaf": "201-500 คน",
  "3bcdaf7160": "501-2000 คน",
  "ab0b2333fe": "มากกว่า 2000 คน",
  "4f756eedc8": "บทบาทของคุณคือ",
  "3ba0b502c3": "ผู้จัดการทั่วไป",
  "702099cc72": "การเงิน",
  "843b603162": "จัดซื้อ",
  "8b414a9b44": "บุคลากร/ธุรการ",
  "92486b2908": "การขาย",
  "ac4e7fb063": "องค์กรของคุณมีงบประมาณหรือแผนการจัดซื้อซอฟต์แวร์สำนักงานหรือไม่",
  "37634c72dc": "ภายใน 6 เดือน",
  "bd94b6deec": "ภายใน 1 ปี",
  "713f4aad5c": "กำลังพิจารณา",
  "c5ea095a4d": "ไม่มีแผน",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> สร้างทีมและเชิญสมาชิกเพื่อร่วมมือกัน",
  "9d27dc2d90": "สามารถป้อนชื่อทีมที่อยู่หรือโครงการที่สนใจล่าสุด",
  "de19c8509a": "คุณอาจต้องสร้าง:",
  "1a84699223": "ฝ่ายการขาย",
  "efab59502b": "ฝ่ายผลิตภัณฑ์",
  "7e599b3713": "ฝ่ายปฏิบัติการภาคใต้",
  "bf494779c2": "ฝ่ายจัดซื้อ",
  "f3a60ab34d": "ฝ่ายธุรการ",
  "bbc50c1ac8": "ฝ่ายการเงินภาคเหนือ",
  "32629e3dac": "ฝ่ายการเงินผลิตภัณฑ์",
  "5524d354ba": "ฝ่ายไอที",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>คุณได้ปลดล็อกสิทธิพิเศษสำหรับมือใหม่แล้ว!</span> เชิญอีก 3 คนเพื่อรับพื้นที่ <span style='color: rgb(206,131,62);'>4T และสิทธิ WPS AI</span>",
  "939eb98492": "<span style='color: rgb(206,131,62);'>คุณได้ปลดล็อกสิทธิ์อัปโหลดไฟล์เดี่ยวสูงสุด 4G สำหรับ 50 คนแล้ว</span> เชิญอีก 3 คนเพื่อปลดล็อก WPS AI 30 วันและพื้นที่ 4T",
  "136c26d941": "คัดลอกลิงก์ด้านล่างเพื่อเชิญสมาชิกเข้าร่วม",
  "3de5c12558": "คัดลอกลิงก์เพื่อเชิญเพื่อนร่วมงาน",
  "a5d64b14f3": "คำแนะนำข้อมูลบริษัท",
  "b8f2492701": "การรวบรวมข้อมูลบริษัท",
  "1f9d053dc0": "สร้างเทมเพลตทีม",
  "0e83c79a88": "เชิญสมาชิก",
  "821fc1906a": "เข้าสู่องค์กร",
  "463e14ae9c": "โปรดเลือกทีม",
  "690f0cdb9e": "ไอคอนเสร็จสิ้น",
  "c340522a17": "ก่อนหน้า",
  "f9355c72ef": "ข้าม",
  "bd6c09ebbb": "ถัดไป",
  "2a2603cd3f": "สแกนโค้ดเพื่อส่งคำเชิญให้เพื่อนร่วมงาน",
  "411e64907a": "คัดลอก",
  "b0d988cf23": "ดาวน์โหลด",
  "e3c0b650ac": "คัดลอกเรียบร้อยแล้ว",
  "713ac624b4": "ยินดีต้อนรับสู่ WPS 365",
  "b8fff97849": "องค์ประกอบเป้าหมายไม่ถูกต้อง",
  "02acdcf296": "แปลง html2canvas ล้มเหลว ไม่ได้สร้าง canvas",
  "a76988c496": "แปลง canvas เป็น blob ล้มเหลว",
  "af89584edf": "Clipboard API ไม่พร้อมใช้งาน",
  "f90263bbde": "ล้มเหลวในการคัดลอกภาพ",
  "71b05319da": "แปลง html เป็น canvas ล้มเหลว",
  "38852999fe": "บันทึกข้อมูลล้มเหลว",
  "4a4c621d07": "การสร้างทีมล้มเหลว กรุณาลองใหม่ในภายหลัง",
  "d239a23994": "หน้าปัจจุบันจำกัดการเข้าถึงเฉพาะบัญชีองค์กร กรุณาเข้าสู่ระบบด้วยบัญชีองค์กรก่อน",
  "d93bfb7fb9": "โปรดป้อนเนื้อหา",
  "42b81a66c4": "ความยาว 2 ถึง 100 ตัวอักษร",
  "76d33733db": "ห้ามมีอักขระพิเศษ เช่น / \\ ; : * ? \" < > | % &",
  "dc55d1f62f": "ไปเพื่อสัมผัส",
  "b25233cba0": "การทำงานร่วมกันในเอกสาร+การสื่อสารแบบเรียลไทม์ เปิดวิธีการทำงานอย่างมีประสิทธิภาพ",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> เริ่มแชทร่วมมือ แบ่งปันเอกสารอย่างปลอดภัยและสะดวก",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> ผู้ช่วย AI อัจฉริยะที่สร้างขึ้นมาเพื่อการทำงานสำนักงาน",
  "e338385bc9": "ตัวช่วยอัจฉริยะในการทำงานกับ Office ซึ่งมีการรวม AI เข้ากับซอฟต์แวร์สำนักงาน ทำให้ทุกคนมีผู้ช่วย AI",
  "7ae1f3b1c6": "การนำเข้าไฟล์(โฟลเดอร์)เสร็จสิ้น สามารถดูผลการนำเข้าได้ใน \"เอกสารคลาวด์ของฉัน\"",
  "85db2a024a": "เกิดข้อผิดพลาดในการนำเข้าไฟล์(โฟลเดอร์) สามารถลองอีกครั้งในภายหลัง",
  "9ff74c802a": "ดาวน์โหลดเวอร์ชันสำหรับชิป Intel",
  "ab44928f02": "ดาวน์โหลดเวอร์ชันสำหรับชิป Apple",
  "a08d937c38": "กำลังอัปโหลดไฟล์(โฟลเดอร์) สามารถดูได้หลังจากเสร็จสิ้นใน \"เอกสารคลาวด์ของฉัน\"",
  "68db1829fa": "รองรับการนำเข้าจากบัญชีส่วนตัวเท่านั้น กรุณาเข้าสู่ระบบบัญชีส่วนตัวแล้วลองอีกครั้ง",
  "1185a7c7ab": "น้อยกว่า 20 คน",
  "e2bcc252c9": "21-300 คน",
  "3c4842f1ea": "301-1000 คน",
  "1bbee64cfa": "มากกว่า 1000 คน",
  "388ff4a035": "อาจารย์",
  "d341b1d794": "นักศึกษา",
  "bfb2ee4148": "เพิ่มเติม",
  "f6450c3f31": "การจัดการโครงการ",
  "b87fd33a0d": "แผนรายปี",
  "0dd45a1c14": "การจัดการประสิทธิภาพของพนักงาน",
  "67fa01cac6": "กิจกรรมการตลาด",
  "6dd82cc031": "การสรรหาพนักงาน",
  "a7edaed91d": "เอกสารประกอบการสอน",
  "bf12b7efb0": "การจัดการแผนการสอน",
  "c35ae8f358": "เอกสารผลิตภัณฑ์",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS ตารางหลายมิติ สร้างระบบธุรกิจเฉพาะของคุณด้วยการมองเห็น",
  "72286d5519": "👏แนะนำแม่แบบ",
  "0bc00ee949": "การจัดการข้อบกพร่องของความต้องการ",
  "e22f3d56f7": "การจัดการเนื้อหาการสร้างสรรค์",
  "dd439de3dd": "ระบบการจัดการลูกค้า",
  "fbb2bbf82e": "แผนการเตรียมสอบ",
  "0645b908bc": "การค้นหาตารางเงินเดือน",
  "813b3d3d7e": "การจัดการโอเคอาร์",
  "918e33d5bd": "สร้างด้วยหนึ่งคลิก",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> นำเข้าเอกสารที่ใช้บ่อยเพื่อความสะดวกในการใช้งาน",
  "c58f28713c": "นำเข้าจากท้องถิ่น",
  "9d6a0a4370": "รองรับรูปแบบไฟล์ Office ที่พบประจำ",
  "54c48aee85": "เลือกไฟล์",
  "c5b593e452": "นำเข้าจากบัญชีส่วนตัว",
  "4bdcd9d4c5": "นำเข้าเอกสาร ทีม และโฟลเดอร์จากบัญชีส่วนตัวได้ในคลิกเดียว",
  "99b2968905": "นำเข้าอำนาจ",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> ดาวน์โหลดไคลเอนต์ WPS Teams",
  "fe46574227": "การทำงานร่วมกันของเอกสาร + การสื่อสารทันที วิธีใหม่ในการทำงานอย่างมีประสิทธิภาพ",
  "beefe5a09b": "ดาวน์โหลดทันที",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> การตั้งค่าความปลอดภัยที่หลากหลาย เพื่อปกป้องความปลอดภัยของข้อมูล",
  "b4e70dbeab": "WPS มีความเชี่ยวชาญในด้านความปลอดภัยของเอกสารมาหลายปี เพื่อปกป้องข้อมูลสำคัญขององค์กร",
  "42dc772619": "ไฟล์ใหญ่เกินไป แนะนำให้นำเข้าภายหลังที่หน้าแรกแล้วลองใหม่",
  "a052564e47": "เกิดข้อผิดพลาดในการสร้าง โปรดลองใหม่ภายหลัง"
}